import { useMemo, useRef, useSyncExternalStore } from "react";
import { createLocalForageStore } from "./store.js";
import { LocalForageError } from "./types.js";
function useLocalForage(key, initialValue) {
  var _a, _b;
  const isIframe = typeof window !== "undefined" && window.self !== window.top;
  const memoDefault = useMemo(() => ({ data: initialValue }), [initialValue]);
  const storeRef = useRef(null);
  const lastValue = useRef(null);
  if (!storeRef.current) {
    if (isIframe) {
      storeRef.current = {
        subscribe: () => () => {
        },
        clear: async () => {
          return {};
        },
        setValue: async (v) => ({ data: v })
      };
    } else {
      storeRef.current = createLocalForageStore(key, initialValue);
    }
  }
  const getSnapshot = () => {
    var _a2;
    if (isIframe) {
      return memoDefault;
    }
    const value = (_a2 = storeRef.current) == null ? void 0 : _a2.getSnapshot();
    if (value === lastValue.current) return lastValue.current;
    lastValue.current = value;
    return value;
  };
  const getServerSnapshot = () => {
    return {
      data: null,
      error: new LocalForageError("Not applicable to server"),
      success: false
    };
  };
  const result = useSyncExternalStore(
    // @ts-expect-error storeRef could be mocked
    storeRef.current.subscribe,
    getSnapshot,
    getServerSnapshot
  );
  return {
    clearValue: (_a = storeRef.current) == null ? void 0 : _a.clear,
    data: (result == null ? void 0 : result.success) ? result.data : null,
    error: (result == null ? void 0 : result.success) ? null : (result == null ? void 0 : result.error) || null,
    isError: !(result == null ? void 0 : result.success),
    setValue: (_b = storeRef.current) == null ? void 0 : _b.setValue,
    isStoreInitialized: (result == null ? void 0 : result.isStoreInitialized) || false
  };
}
export {
  useLocalForage
};
